<template>
    <div class="filter-min-max">
        <div class="filter-label" @click="showOptions = !showOptions">
            <div>{{ t('segments-filters-event') }}: {{ selectedEvent ? selectedEvent.title : "" }}</div>
            <div v-is="valueLabel" class="period-label">{{ valueLabel }}</div>
            <span v-if="periodLabel" class="period-label">
                {{ t('segments-filters-period_label', { period: periodLabel }) }}
            </span>
        </div>
        <div
            class="filter-options"
            v-if="showOptions"
            v-click-outside="clickedOutsideOptions"
        >
            <div class="fields">
                <div class="field column">
                    <div>
                        <label :class="{ label: true }">{{ t('segments-filters-which_event') }} </label>
                    </div>
                    <div>
                        <kv-search-select
                            :placeholder="t('segments-filters-search_event')"
                            api-endpoint="custom-event/events"
                            display-field="title"
                            value-field="id"
                            v-model="filterEvent"
                            :min-search-length="1"
                            :fetch-item-endpoint="false"
                            @select="onEventSelected"
                        />
                    </div>
                </div>

                <div class="field">
                    <label>{{ t('reportFilters-min') }}:</label>
                    <input type="tel" v-model="min" v-mask="options.mask" />
                </div>
                <div class="field">
                    <label>{{ t('reportFilters-max') }}:</label>
                    <input type="tel" v-model="max" v-mask="options.mask" />
                </div>

                <div class="field">
                    <label class="checkbox"
                        ><input
                            type="checkbox"
                            v-model="restrictPeriod"
                        />{{ t('segments-filters-limit_time_range') }}</label
                    >
                </div>

                <template v-if="restrictPeriod">
                    <div class="field">
                        <div class="period-title">{{ t('segments-filters-days_ago') }}</div>
                    </div>
                    <div class="field">
                        <label>{{ t('reportFilters-min') }}:</label>
                        <input type="tel" v-model="period.min" />
                    </div>
                    <div class="field">
                        <label>{{ t('reportFilters-max') }}:</label>
                        <input type="tel" v-model="period.max" />
                    </div>
                </template>
            </div>
            <div class="filter-actions">
                <button
                    type="button"
                    class="cancelBtn btn btn-sm btn-default"
                    @click="cancel"
                >
                    {{ t('segments-filters-close') }}
                </button>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.field {
    display: flex;
    &.column {
        flex-direction: column;
        padding: 0 10px;
        label {
            margin-left: 0;
            padding-left: 0;
        }
    }
    label {
        width: auto;
        display: block;
        margin-right: 10px;
    }
}

.period-label {
    display: block;
    font-size: 9px;
}
.filter-actions {
    margin-top: 20px;
}

label.checkbox {
    font-size: 10px;

    input {
        margin-right: 5px;
    }
}

.period-title {
    font-size: 12px;
    font-weight: 600;
    margin: 10px 0 0 10px;
}

input:not([type="checkbox"]) {
    border: none;
    border-bottom: 1px solid #ddd;
    box-shadow: none;
    font-size: 13px;
    flex-grow: 1;
    width: 100%;
    &:focus {
        outline: none;
        box-shadow: none;
        border: none;
        border-bottom: 1px solid #ddd;
    }
}
</style>
<script>
import keviApi from "../../keviApi.js";
import KvSearchSelect from "../../components/ui/kv-search-select.vue";

export default {
    name: "filter-custom-events",
    components: {
        KvSearchSelect
    },
    props: {
        currentValue: {
            type: Object,
            default: () => ({
                min: null,
                max: null,
                eventId: null,
                restrictPeriod: false,
                period: {
                    min: null,
                    max: null,
                },
            }),
        },
        options: {
            type: Object,
            default: () => ({
                mask: "R$ ######,##",
                optionsWidth: 300,
            }),
        },
        name: {
            type: String,
            default: "min-max",
        },
    },
    data() {
        return {
            showOptions: false,
            clickedOutsideOptions: () => {},
            value: "",
            changedValue: false,
            min: null,
            max: null,
            period: {
                min: null,
                max: null,
            },
            filterEvent: "",
            restrictPeriod: false,
            selectedEvent: null,
            loading: false,
        };
    },
    mounted() {
        if (this.currentValue) {
            let value = this.currentValue;
            this.max = value.max;
            this.min = value.min;
            this.restrictPeriod = value.restrictPeriod;
            this.period.min = value.period.min;
            this.period.max = value.period.max;
            this.filterEvent = value.eventId;
        }
        if (this.value.length > 0) {
            this.changed();
        }
        if (this.filterEvent) {
            this.fetchEvent(this.filterEvent);
        }
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        fetchEvent(id) {
            if (!id) return;
            this.loading = true;
            let options = keviApi.getOptions(`custom-event/events/${id}`);
            this.$http(options).then((response) => {
                if (response.status === 200) {
                    this.selectedEvent = response.body;
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        cancel() {
            this.showOptions = false;
        },
        onEventSelected(event) {
            this.selectedEvent = event;
            this.filterEvent = event.id;
        },
        changed() {
            this.$emit("changed", this.value);
        },
        checkValuesOrder() {
            if (this.max && this.maxFloat < this.minFloat) {
                let max = this.max;
                let min = this.min;
                this.max = min;
                this.min = max;
            }

            if (
                this.period.max &&
                this.getFloat(this.period.max) < this.getFloat(this.period.min)
            ) {
                let periodMax = this.period.max;
                let periodMin = this.period.min;
                this.period.max = periodMin;
                this.period.min = periodMax;
            }
        },
        setValue() {
            this.checkValuesOrder();
            this.value = {
                min: this.minFloat,
                max: this.maxFloat,
                eventId: this.filterEvent,
                restrictPeriod: this.restrictPeriod ? 1 : "",
                period: {
                    min: this.getFloat(this.period.min),
                    max: this.getFloat(this.period.max),
                },
            };
        },
        getFloat(n) {
            if (n === null) {
                return null;
            }
            return parseFloat(
                String(n)
                    .replace(/[^0-9,]/gi, "")
                    .replace(",", "."),
            );
        },
    },
    computed: {
        maxFloat() {
            return this.getFloat(this.max);
        },
        minFloat() {
            return this.getFloat(this.min);
        },

        valueLabel() {
            const isEmpty = (v) => v === null || v === "" || v === undefined;
            if (isEmpty(this.min) && isEmpty(this.max)) {
                return "";
            } else if (isEmpty(this.min) && !isEmpty(this.max)) {
                return this.t('segments-filters-until') + " " + this.max + " " + this.t('segments-filters-executions');
            } else if (!isEmpty(this.min) && isEmpty(this.max)) {
                return this.t('segments-filters-from') + " " + this.min + " " + this.t('segments-filters-executions');
            } else {
                return this.t('segments-filters-between') + " " + this.min + " " + this.t('segments-filters-and') + " " + this.max + " " + this.t('segments-filters-executions');
            }
        },
        periodLabel() {
            if (!this.restrictPeriod) {
                return "";
            }
            if (!this.period.min && !this.period.max) {
                return "";
            } else if (!this.period.min && this.period.max) {
                return this.t('segments-filters-until') + " " + this.period.max;
            } else if (!this.period.max && this.period.min) {
                return this.t('segments-filters-more_than') + " " + this.period.min;
            } else {
                return this.t('segments-filters-between') + " " + this.period.min + " " + this.t('segments-filters-and') + " " + this.period.max;
            }
        },
    },
    watch: {
        showOptions() {
            this.setValue();
            if (this.showOptions) {
                window.setTimeout(() => {
                    this.clickedOutsideOptions = () => {
                        if (this.showOptions) {
                            this.cancel();
                        }
                    };
                }, 100);
            } else {
                this.clickedOutsideOptions = () => {};
            }
        },
        value() {
            this.changed();
        },
    },
};
</script>
